import React, { useState, useEffect, useMemo } from 'react';
import renderStats from '../components/renderStats';

import '../css/buff.css'

const BuffWrapper = ({ buffs, setActiveBuffs }) => {
  const [localBuffs, setLocalBuffs] = useState(() =>
    buffs.map(buff => ({
      ...buff,
      stackCount:
        Array.isArray(buff.stats) && buff.stats.length > 0 ? buff.stackLimit ?? 1 : 0,
    }))
  );

  useEffect(() => {
    setLocalBuffs(prev => {
      const prevMap = new Map(prev.map(b => [b.name, b]));

      return buffs.map(buff => {
        if (prevMap.has(buff.name)) {
          // Existing buff
          return { ...buff, stackCount: prevMap.get(buff.name).stackCount };
        } else {
          // New buff
          return {
            ...buff,
            stackCount:
              Array.isArray(buff.stats) && buff.stats.length > 0 ? buff.stackLimit ?? 1 : 0,
          };
        }
      });
    });
  }, [buffs]);

  const activeBuffsMemo = useMemo(() => {
    return localBuffs
      .filter(buff => Array.isArray(buff.stats) && buff.stats.length > 0 && buff.stackCount !== 0)
      .map(buff => ({
        ...buff,
        stats: buff.stats.map(stat => ({ ...stat, value: stat.value })),
      }));
  }, [localBuffs]);

  useEffect(() => {
    setActiveBuffs(activeBuffsMemo);
  }, [activeBuffsMemo, setActiveBuffs]);

  const handleStackChange = (index, value) => {
    const parsed = Number(value);
    setLocalBuffs(prev => {
      const updated = [...prev];
      const clamped = Math.max(
        0,
        Math.min(isNaN(parsed) ? 0 : parsed, updated[index].stackLimit ?? Infinity)
      );
      updated[index] = { ...updated[index], stackCount: clamped };
      return updated;
    });
  };

  const handleToggle = (index, enabled) => {
    setLocalBuffs(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], stackCount: enabled ? 1 : 0 };
      return updated;
    });
  };



  return (
    <div className="buffWrapper">
      <h2 className="sectionTitle">Active Buffs</h2>
      {localBuffs
        .filter((buff) => Array.isArray(buff.stats) && buff.stats.length > 0)
        .map((buff, index) => {
          const { stackCount } = buff;
          const isActive = stackCount > 0;
          const hidden = buff.hidden ? "hidden"  : ""

          const scaledStats = isActive
            ? buff.stats.map((stat) => ({
                ...stat,
                stackCount: stackCount
              }))
            : [];

          return (
            <div
              className={`buffContainer ${isActive ? 'active' : 'inactive'} ${hidden}`}
              key={index}
            >
              <strong className="buffName">{buff.name}</strong>{' '}
              <span className="buffType">({buff.type})</span>

              {buff.stackLimit !== undefined ? (
                <div className="stackCounter">
                  <label>
                    <strong>Stacks:</strong>{' '}
                    <input
                      type="number"
                      min="0"
                      max={buff.stackLimit}
                      value={Number.isFinite(stackCount) ? stackCount : 0}
                      onChange={(e) =>
                        handleStackChange(index, parseInt(e.target.value, 10))
                      }
                      className="stackInput"
                    />{' '}
                    / {buff.stackLimit}
                  </label>
                </div>
              ) : (
                <div className="enabledToggle">
                  <label>
                    <input
                      className="enabledForm"
                      type="checkbox"
                      checked={isActive}
                      onChange={(e) => handleToggle(index, e.target.checked)}
                    />{' '}
                    Enabled
                  </label>
                </div>
              )}

              <div className="buff statContainer">
                Stats:
                <div className='buff statNumber'>
                {renderStats(scaledStats)}
                </div>
                {buff.buffAmpable === true && (
                  <div className="ampLabel">Affected by Buff Amp</div>
                )}
                {buff.debuffAmpable === true && (
                  <div className="ampLabel">Affected by Debuff Amp</div>
                )}
              </div>
            </div>
          );
        })}
    </div>

  );
};

export default BuffWrapper;
